'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dRestricted$002dDomains$0024 from "./presto.-List-Restricted-Domains$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481 from "./presto.-Presto-Router$$anon$81.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$80() {
  this.bnQ = null;
  this.bnI = null;
  this.bnJ = false;
  this.bnR = null;
  this.bnS = false;
  this.bnV = null;
  this.bnO = null;
  this.bnP = false;
  this.bnK = null;
  this.bnL = false;
  this.bnM = null;
  this.bnN = false;
  this.bnT = false;
  this.bnU = false;
  this.bnQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bnV = "ListRestrictedDomains";
}
export { $c_Lpresto_PrestoRouter$$anon$80 as $c_Lpresto_PrestoRouter$$anon$80 };
$p = $c_Lpresto_PrestoRouter$$anon$80.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$80;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$80() {
}
export { $h_Lpresto_PrestoRouter$$anon$80 as $h_Lpresto_PrestoRouter$$anon$80 };
$h_Lpresto_PrestoRouter$$anon$80.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bnQ;
});
$p.L = (function() {
  if ((!this.bnJ)) {
    this.bnI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bnJ = true;
  }
  return this.bnI;
});
$p.O = (function() {
  if ((!this.bnS)) {
    this.bnR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bnS = true;
  }
  return this.bnR;
});
$p.E = (function() {
  return this.bnV;
});
$p.t = (function() {
  if ((!this.bnP)) {
    this.bnO = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnP = true;
  }
  return this.bnO;
});
$p.M = (function() {
  if ((!this.bnL)) {
    this.bnK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bnL = true;
  }
  return this.bnK;
});
$p.Q = (function() {
  if ((!this.bnN)) {
    this.bnM = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002481.$c_Lpresto_PrestoRouter$$anon$81();
    this.bnN = true;
  }
  return this.bnM;
});
$p.w = (function() {
  if ((!this.bnU)) {
    this.bnT = false;
    this.bnU = true;
  }
  return this.bnT;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee535) => ((p) => \u03b4scrutinee535))($j_presto$002e$002dList$002dRestricted$002dDomains$0024.$m_Lpresto_ListRestrictedDomains$())));
});
var $d_Lpresto_PrestoRouter$$anon$80 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$80, "presto.PrestoRouter$$anon$80", ({
  OP: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$80 as $d_Lpresto_PrestoRouter$$anon$80 };
//# sourceMappingURL=presto.-Presto-Router$$anon$80.js.map
